import { InjectionToken } from '@angular/core';

export interface BackendUrlMapping {
  /** URL pública tal como la arma el código (environment.baseApiUrl, etc.) */
  external: string;
  /** URL de red interna a usar cuando la petición se origina en SSR */
  internal: string;
}

/**
 * Mapeo dominio-público -> dominio-interno para peticiones al backend.
 * - Cliente (app.config.ts): array vacío -> el interceptor es un no-op.
 * - SSR (app.config.server.ts): se puebla con las URLs internas (docker/k8s).
 */
export const BACKEND_URL_MAP = new InjectionToken<BackendUrlMapping[]>(
  'BACKEND_URL_MAP',
  { factory: () => [] }
);
